import {ModuleWithProviders} from '@angular/core';
import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {SignInComponent} from './sign-in/sign-in.component';
import { AuthGuard } from "./_guards/auth.guard";
import { FamilyRoomDirectoryComponent } from "./family-room-directory/family-room-directory.component";
import {ADFSCallbackComponent} from './sign-in/adfs-callback/adfs-callback.component';


const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: 'family-room-directory'},
  {path: 'family-room-directory', component: FamilyRoomDirectoryComponent, canActivate: [AuthGuard]},
  {path: 'sign-in/adfs-callback', component: ADFSCallbackComponent},
  {path: 'sign-in', component: SignInComponent},
  {path: '**', redirectTo: 'sign-in'},
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  scrollOffset: [0, 64],
};

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, routerOptions);
